<script setup lang="ts">
  import type { AcceptableValue } from '#ui/types';

  withDefaults(
    defineProps<{
      isInvalid?: boolean;
      variant?: 'outline' | 'soft' | 'subtle';
      baseStyles?: string;
    }>(),
    {
      variant: 'outline',
      baseStyles: '',
    },
  );

  const attrs = useAttrs();
  const modelValue = defineModel<AcceptableValue>();
</script>

<template>
  <UInput
    v-model="modelValue"
    :variant="variant"
    v-bind="attrs"
    :ui="{ base: `h-11 pl-4 rounded-md font-barlow text-base w-full pr-4 ${baseStyles}`, root: 'w-full' }"
  >
    <template v-if="$slots.trailing" #trailing>
      <slot name="trailing"></slot>
    </template>
    <template v-else-if="!$slots.trailing && variant === 'subtle' && modelValue" #trailing>
      <SvgoRedCancel v-if="isInvalid" class="size-5" />
      <SvgoGreenTick v-else class="size-5" />
    </template>
    <template #leading>
      <slot name="leading"></slot>
    </template>
  </UInput>
</template>
